/**
 Project	IAM - Validation

 @file 	    import-user-report.model.ts
 @author  	Martin Tazlari <martin.tazlari@ictvs.ch>
 @copyright © 2018, ICT-vs. All rights reserved.
 **/

export class ImportUserReport {
  status: 'Success' | 'Error';
  userImported: string;
  message: string;
}
